import theme from '../components/theme';

const getHighlightSeverityColor = ({highlightSeverity}) => ({
  error: theme.error,
  warning: theme.warningColors.border,
}[highlightSeverity]);

export default getHighlightSeverityColor;
